module.exports = __webpack_public_path__ + "img/5.8c8c70f5.jpg";